import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const Calendra = (props) => {
    return (
        <div className="datepicker">
            <DatePicker
                dateFormat="yyyy-MM-dd"
                maxDate={props.endDate}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                onChange={(e) => {
                    props.handleDateChange(e)
                }}
                selected={props.defaultDate}
                isClearable={false}
                placeholderText={props.placeholder}
            />
        </div>
    );
}
const Calendra2 = (props) => {
    return (
        <div className="datepicker">
            <DatePicker
                dateFormat="yyyy-MM-dd"
                minDate={props.startDate}
                maxDate={props.endDate}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                onChange={(e) => {
                    props.handleDateChange(e)
                }}
                selected={props.defaultDate}
                isClearable={false}
                placeholderText={props.placeholder}
            />
        </div>
    );
}
export { Calendra, Calendra2 }